// @flow
import { getPhoneNumberNormalizerWithLength } from './get-phone-number-normalizer';
import { LATAM_PHONE_MASK } from '@tectonics/commons/masks';
import type { PhoneNumberConfig } from './types';

export const genericPhoneNumber: PhoneNumberConfig = {
  inputFieldName: 'genericPhoneNumber',
  labelKey: 'volcanes.customerForm.phoneNumber.label',
  placeholderKey: 'volcanes.customerForm.phoneNumber.placeholder',
  normalizer: getPhoneNumberNormalizerWithLength(20),
  mask: LATAM_PHONE_MASK,
};
